function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "85o3q2x6ea",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 89.871,
  cy: 90.087,
  r: 89.678,
  fill: "url(#85o3q2x6ea)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89.871,
  cy: 90.087,
  r: 88.192,
  fill: "#1FA0FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89.871,
  cy: 90.087,
  r: 70.107,
  fill: "#DDE1EC"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#535461",
  d: "M87.889 32.366H91.853V94.298H87.889z",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  opacity: 0.1,
  transform: "translate(52.231 69.92)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.851 18.681H97.838V23.636000000000003H41.851z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.311 -8.32H21.266V31.445H16.311z",
  transform: "rotate(-62.36 18.789 11.563)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.64,
  cy: 21.159,
  r: 7.432
})), /*#__PURE__*/React.createElement("path", {
  fill: "#535461",
  d: "M94.083 87.609H150.07V92.564H94.083z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#535461",
  d: "M51.153 78.02H90.918V82.975H51.153z",
  transform: "rotate(27.64 71.036 80.497)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89.871,
  cy: 90.087,
  r: 7.432,
  fill: "#535461"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M25.209 98.51c0-38.72 31.387-70.108 70.107-70.108 22.035-.02 42.792 10.337 56.027 27.954-11.93-21.681-34.97-36.377-61.477-36.377-38.72 0-70.107 31.388-70.107 70.108-.023 15.21 4.924 30.013 14.088 42.153-5.683-10.333-8.655-21.938-8.638-33.73z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M141.466 56.599s-.904 2.15-.454 2.829M105.37 55.92s.452 2.15 0 2.829",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(91.714 48)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.497,
  cy: 3.677,
  r: 3.497,
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBEBE",
  d: "M16.175 14.06L14.413 12.348 10.876 13.447 11.216 17.542 18.489 17.205 16.255 14.168z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.322,
  cy: 8.37,
  r: 5.654,
  fill: "#FBBEBE"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M47.425 21.318s6.946 11.937 8.6 13.73c.786.881 1.623 1.716 2.508 2.5 0 0-.777 2.577-2.015 2.485-.706-.042-1.398-.213-2.042-.503 0 0-.552-1.432-1.516-2.06-.964-.628-8.837-8.374-8.653-10.85.184-2.475 3.118-5.302 3.118-5.302z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M22.686 38.353s7.407 5.749 17.473.347l.867-.638s-1.464 3.293-1.6 4.186c-.157 1.035-3.969 7.1-4.59 7.39-.622.29-.76.558-.76.558l2.64 2.906.976-.719s3.805-5.39 4.918-6.377c1.113-.986 6.415-11.157 6.415-11.157s2.028-3.832-3.032-4.12c-5.06-.288-7.388 1.09-7.388 1.09l-8.98 1.427-6.939 5.107zM58.619 36.983l3.746 2.592s4.78 1.497 1.835 2.494c-2.944.996-10.702 1.357-10.878-.018-.176-1.375.306-3.54.693-3.42.387.118 3.074.815 4.604-1.648z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M38.023 51.493l.694 3.808s1.971 3.77-.396 2.6-7.244-5.614-6.524-6.545c.72-.932 2.31-1.943 2.471-1.639.161.304 1.356 2.336 3.755 1.776z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M30.88 34.496s-5.035 5.878-8.091 4.45C19.732 37.52 7.226 20.98 8.654 17.923c1.428-3.057 1.907-2.406 1.907-2.406l6.457.597-1.858-2.979s.868-.638 1.694.258c.827.896 4.145 3.134 5.301 6.295 1.157 3.161 4.55 3.003 4.55 3.003l4.175 11.805z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M51.212 22.375L42.484 31.639 34.666 17.836 42.099 8.856z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M50.553 22.275L42.671 30.416 35.528 17.871 42.078 9.623z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3B3B3",
  d: "M42.057 31.286L42.484 31.639 42.21 32.175 30.006 35.808 29.891 35.39 30.446 34.815z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0CDE1",
  d: "M42.593 31.56L29.955 35.511 22.252 20.954 34.666 17.836z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "M41.641 29.585L41.099 29.984 35.082 19.536 35.704 19.246zM40.397 30.166L35.052 31.76 28.983 21.016 34.272 19.798z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBEBE",
  d: "M25.337 22.194l1.107-.313s6.172-.698 6.263 1.242c.09 1.94-7.092 1.04-7.092 1.04l-.957-1.302.679-.667zM30.751 30.914l1.54-.633s4.65-2.085 3.317-3.443c-1.334-1.358-5.448 1-5.448 1l-.788.748 1.379 2.328z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.378 27.912s2.508 2.5 1.938 3.088c-.571.587-9.93 8.31-12.251 5.84-2.32-2.472-13.625-14.88-9.226-15.944 4.399-1.064 5.56 1.423 5.56 1.423l5.808 9.935 8.171-4.342zM21.867 20.318L25.988 21.715 25.92 24.69 21.562 24.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M25.581 29.453L21.141 32.052 16.069 24.251 20.965 30.677z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.84,
  cy: 6.731,
  r: 6.731,
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1FA0FF",
  d: "M46.212 22.963L41.498 16.068 43.496 13.594 48.394 20.688z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "M46.079 25.735L38.903 15.303 39.257 14.875 46.399 25.332zM45.154 26.749L37.979 16.318 38.333 15.89 45.475 26.347zM44.366 27.496L37.191 17.065 37.545 16.637 44.687 27.094z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M12.821 2.237h2.083c2.195 0 3.975 1.78 3.975 3.976h-6.058V2.237z"
})));

function SvgComingSoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.0161d484.svg";
export { ForwardRef as ReactComponent };